import * as dxNotify from 'devextreme/ui/notify';

export function notify(message: string, type?: string, displayTime?: number) {
    dxNotify.default({message, position: {my: 'center', at: 'top', of: window, offset: '0 110'}}, type || 'success', displayTime || 3000);
}
